import axios from "../plugins/parseAxios";
export class ProductAPI {
  constructor(props) { }
  static getProducts(payload) {
    return axios.post("functions/getProducts", payload);
  }
}
